import { NextRequest } from 'next/server';

export const X_PATH_WITH_QUERY = 'x-path-with-query';

/**
 * App Router layouts/Server Components only see their own route segment's params,
 * not the full request path. Middleware is the only place the real path is
 * available before render — forward pathname + query as a header so server code
 * (redirects, callbackUrl construction, etc.) can return the user to the exact page,
 * including its search params.
 */
export const setPathWithQueryToRequestHeader = (request: NextRequest, requestHeaders: Headers): void => {
  requestHeaders.set(X_PATH_WITH_QUERY, request.nextUrl.pathname + request.nextUrl.search);
};
